<template>
  <div class="video-event">
    <div class="section-header">
      <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="5" width="18" height="14" rx="2"></rect>
        <path d="M8 21h8M12 17v4"></path>
      </svg>
      <h3>{{ title || '监控事件轮播' }}</h3>
      <span class="count">{{ list.length }} 条</span>
    </div>

    <div v-if="!list.length" class="empty">暂无监控事件</div>
    <div v-else class="event-grid">
      <div v-for="(slot, index) in slots" :key="index" class="event-tile">
        <template v-if="slot">
          <img v-if="slot.image" :src="slot.image" class="image" />
          <div v-else class="no-image">暂无图片</div>

          <div class="overlay-top">
            <span class="event-name">{{ slot.name }}</span>
            <span v-if="slot.level_label" class="level" :class="levelClass(slot.level)">
              {{ slot.level_label }}
            </span>
          </div>

          <div class="time">{{ slot.time }}</div>
        </template>
        <div v-else class="no-image">暂无事件</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchVideoGatewayEvents } from '../utils/api.js'

export default {
  name: 'VideoEventCarousel',
  props: {
    title: {
      type: String,
      default: ''
    },
    events: {
      type: Array,
      default: () => []
    },
    refreshInterval: {
      type: Number,
      default: 5 * 60 * 1000
    }
  },
  data() {
    return {
      list: [],
      refreshTimer: null
    }
  },
  computed: {
    slots() {
      return Array.from({ length: 4 }, (_, index) => this.list[index] || null)
    }
  },
  watch: {
    events: {
      immediate: true,
      handler(value) {
        this.list = Array.isArray(value) ? value.slice(0, 4) : []
      }
    }
  },
  mounted() {
    this.refreshTimer = setInterval(this.refresh, this.refreshInterval)
    if (!this.list.length) {
      this.refresh()
    }
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    async refresh() {
      try {
        const data = await fetchVideoGatewayEvents()
        this.list = Array.isArray(data) ? data.slice(0, 4) : []
      } catch (error) {
        console.error('监控事件刷新失败:', error)
      }
    },
    levelClass(level) {
      if (level === 'CRITICAL') return 'level-critical'
      if (level === 'ALARM') return 'level-alarm'
      if (level === 'WARNING') return 'level-warning'
      return ''
    }
  }
}
</script>

<style scoped>
.video-event {
  background: rgba(26, 54, 93, 0.6);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(99, 179, 237, 0.2);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(99, 179, 237, 0.2);
  flex-shrink: 0;
}

.icon {
  width: 20px;
  height: 20px;
  color: #63b3ed;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  color: #e2e8f0;
  margin: 0;
}

.count {
  margin-left: auto;
  font-size: 12px;
  color: #a0aec0;
}

.event-grid {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.event-tile {
  position: relative;
  min-width: 0;
  min-height: 0;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(16, 38, 70, 0.6);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.no-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 48px;
  font-size: 12px;
  color: #718096;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-size: 12px;
  color: #718096;
  background: rgba(16, 38, 70, 0.35);
  border-radius: 8px;
}

.overlay-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  background: linear-gradient(180deg, rgba(3, 10, 20, 0.78), transparent);
}

.event-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #f2f7ff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
}

.level {
  flex-shrink: 0;
  font-size: 11px;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid transparent;
}

.level-critical {
  color: #fc8181;
  background: rgba(252, 129, 129, 0.18);
  border-color: rgba(252, 129, 129, 0.45);
}

.level-alarm {
  color: #f6ad55;
  background: rgba(246, 173, 85, 0.18);
  border-color: rgba(246, 173, 85, 0.45);
}

.level-warning {
  color: #63b3ed;
  background: rgba(99, 179, 237, 0.18);
  border-color: rgba(99, 179, 237, 0.45);
}

.time {
  position: absolute;
  right: 8px;
  bottom: 8px;
  padding: 2px 7px;
  border-radius: 4px;
  background: rgba(3, 10, 20, 0.75);
  font-size: 11px;
  font-family: "Bahnschrift", "DIN Alternate", sans-serif;
  color: #e2e8f0;
  letter-spacing: 0.4px;
}
</style>
